import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/silae-papillon.svg'


const _withScopeId = n => (_pushScopeId("data-v-883cb7f6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-login" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"sqg-login__left\" data-v-883cb7f6><div class=\"sqg-login__logo\" data-v-883cb7f6><img alt=\"logo\" src=\"" + _imports_0 + "\" data-v-883cb7f6></div><div class=\"sqg-login__title\" data-v-883cb7f6><div class=\"sqg-login__mainTitle\" data-v-883cb7f6>Silae Onboarding Produit</div><div class=\"sqg-login__subTitle\" data-v-883cb7f6>Espace personnel</div></div></div>", 1)
const _hoisted_3 = { class: "sqg-login__right" }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-lock logo" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sqg-login__formTitle" }, "Connectez vous à votre espace", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Se connecter")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-sign-in-alt" }, null, -1))

import {computed, ref, ComputedRef, defineAsyncComponent} from "vue";
import { useUserStore } from "@/stores/user";
import { updateError } from "@/functions/forms";
import { useRouter } from 'vue-router';
import Input from '@/components/Input.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import FormTemplate from '@/forms/FormTemplate.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const email = ref('');
const password = ref('');
const errorCount = ref(0);
const loader = ref(false);
const canLogin: ComputedRef<boolean> = computed(() => {
  return (email.value.length > 0 && password.value.length > 0 && errorCount.value === 0);
});

const router = useRouter();
const userStore = useUserStore();
const isError = ref(false);

const login = () => {
  loader.value = true;
  userStore.login(model.value[0].value, model.value[1].value).then((response) => {
    if (response.status === 200) {
      loader.value = false;
      router.push('home');
    } else {
      loader.value = false;
      isError.value = true;
      email.value = '';
      password.value = '';
    }
  });
};

//V-MODEL
const model = ref([
    { type: "text", placeholder: "Adresse e-mail", field: "email", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig, isValid: false }] },
    { type: "password", placeholder: "Mot de passe", field: "password", value: '', rules : [{ msg: 'Ce champ est obligatoire', regexp: /^[\s\t\r\n]*\S+/ig, isValid: false }, { msg: 'Le mot de passe doit contenir au moins 4 caractères', regexp: /^.{4,}$/, isValid: false }] },
  ]);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (loader.value)
        ? (_openBlock(), _createBlock(Loader, {
            key: 0,
            msg: "Connexion en cours ..."
          }))
        : (_openBlock(), _createElementBlock("form", {
            key: 1,
            onSubmit: _withModifiers(login, ["prevent"])
          }, [
            _hoisted_5,
            _hoisted_6,
            _createVNode(FormTemplate, { inputs: model.value }, {
              default: _withCtx(({ errorCount }) => [
                _createVNode(Button, {
                  disabled: errorCount !== 0,
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7,
                    _hoisted_8
                  ]),
                  _: 2
                }, 1032, ["disabled"])
              ]),
              _: 1
            }, 8, ["inputs"])
          ], 40, _hoisted_4))
    ])
  ]))
}
}

})